module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAElBMVEUAAAAlJSUmJiYmJiYkJCQkJCRwhb5nAAAABnRSTlMAZj9fODJoNOl9AAAAtUlEQVRIx+2UwQ2DMBAEowQK2FTgdJBH8o+UBpDovxc+SCtz1qDDX++PvfNg2b69DQ0ltX7OnUkqtXOXlkPTQ3rWzkt6xyaVGhSbZmlHGaSfP22WGuRF0Y1rgg0g+wByAUCuAMglArlGIBcBZJRBgDIIUAYByiBAGQQogxBVepr4d7xxPoKew+Rr4Qvmp9Lz6Pj58iDwSF0cTh5zDox89EytEFsScZgL1jlGdCMz/9+GMzSU0wbHyx19Wn/hVwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/poster-delete-icon.png
// module id = 2033
// module chunks = 153